import { render, staticRenderFns } from "./measure.vue?vue&type=template&id=ba21ae0a&scoped=true&"
import script from "./measure.vue?vue&type=script&lang=js&"
export * from "./measure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba21ae0a",
  null
  
)

export default component.exports